import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
  Button,
} from "@chakra-ui/react";
import axios from "../../../axios";
import { errorToast } from "../../../utils/toast";

const SendPendingMessageModal = ({
  isOpen,
  onClose,
  endpoint,
  title = "Send WhatsApp Message",
  description = "This will send WhatsApp message to all pending users.",
  payload = {},
  onSuccess,
  drawer = false,
  children,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleSend = async () => {
    try {
      setLoading(true);

      const res = await axios.post(endpoint, payload);

      alert(res.data.message);

      onSuccess?.();

      onClose();
    } catch (err) {
      errorToast(
        err?.response?.data?.message || "Unable to send message"
      );
    } finally {
      setLoading(false);
    }
  };

  if (drawer) {
    return (
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          <DrawerHeader>{title}</DrawerHeader>

          <DrawerBody>
            {children}
          </DrawerBody>

          <DrawerFooter>
            <Button mr={3} variant="outline" onClick={onClose}>
              Cancel
            </Button>

            <Button
              colorScheme="green"
              onClick={handleSend}
              isLoading={loading}
            >
              Send Message
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>{title}</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          {children || description}
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>

          <Button
            colorScheme="green"
            onClick={handleSend}
            isLoading={loading}
          >
            Send Message
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SendPendingMessageModal;